import { DeviceStatusEnum } from 'api/api_code';
import { snakeCaseToCamelCase } from 'helpers/utils';
import { Translate } from 'next-translate';

/**

 * Returns the list of device status IDs whose translated name 
 * contains the given search string (case-insensitive).

*/
export function getMatchingStatusIds(
	search: string | null | undefined,
	t: Translate
): string[] {
	if (!search?.trim()) return [];

	const term = search.toLowerCase();

	return Object.values(DeviceStatusEnum).filter((id) =>
		t(`status.values.${snakeCaseToCamelCase(id)}`)
			.toLowerCase()
			.includes(term)
	);
}
